<template>
  <div class="navbar">
    <div class="navbar-left">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb></breadcrumb>
    </div>
    <div class="navbar-right">
      <div class="user-block">
        <div class="user-avatar">{{ avatarText }}</div>
        <div class="user-meta">
          <div class="user-name">{{ username || '管理员' }}</div>
          <div class="user-role">系统管理员</div>
        </div>
      </div>
      <el-button type="text" class="logout-btn" @click="logout">退出</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  data() {
    return {
      username: ''
    }
  },
  created() {
    this.username = localStorage.getItem('username')
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    avatarText() {
      const name = this.username || 'A'
      return name.substring(0, 1).toUpperCase()
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push('/admin/entrance')
        location.reload()
      }).catch(err => {
        console.error('Logout failed:', err)
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";

.navbar {
  height: $navbarHeight;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 8px;
  background: #ffffff;
  border-bottom: 1px solid $borderColor;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.navbar-left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.hamburger-container {
  line-height: 1;
  padding: 0 10px;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-block {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #3b82f6, #6366f1);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
}

.user-meta {
  line-height: 1.2;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: $textPrimary;
}

.user-role {
  margin-top: 2px;
  font-size: 12px;
  color: $textSecondary;
}

.logout-btn {
  color: $textSecondary;
  padding: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue